import { Filter } from '@/interfaces/filter.interface'
import store from '@/store'
import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators'
import { APIStatement } from '../../models/api/statement.model'
import { StatementsServices } from '../../services/modules/statements.service'

@Module
export default class StatementStore extends VuexModule {
    statements: object[] = []
    statementsPaginate: object[] = []
    statementForm: object|null = null

    @Mutation
    updateStatements (newStatements: object[]) {
        this.statements = newStatements
    }

    @Mutation
    updateStatementsPaginate (newStatements: object[]) {
        this.statementsPaginate = newStatements
    }

    @Mutation
    updateStatement (newStatement: object) {
        this.statementForm = newStatement
    }

    @Action
    createStatements (params: APIStatement) {
        return new Promise((resolve) => {
            if (!params) {
                store.commit('reportError', { code: 1000, statement: 'Something went wrong :(' })
                resolve()
                return
            }
            const data = Object.assign({}, params)
            data.statementDate = `${params.statementDate}-01`
            StatementsServices.createStatements(data)
                .then(resp => {
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }

    @Action
    editStatements (dataForm: {id: number; params: APIStatement}) {
        return new Promise((resolve) => {
            if (!dataForm.params) {
                store.commit('reportError', { code: 1000, statement: 'Something went wrong :(' })
                resolve()
                return
            }
            const data = Object.assign({}, dataForm.params)
            data.statementDate = `${dataForm.params.statementDate}-01`
            StatementsServices.editStatements(dataForm.id, data)
                .then(resp => {
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }

    @Action
    getStatementsPaginate (params: { page: number; filters?: Filter[]; limit: number; providerId?: number; carrierId?: number; sortBy: string; sort: string }) {
        return new Promise((resolve) => {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const newParams: {[key: string]: any} = {
                page: params.page,
                limit: params.limit,
                providerId: params.providerId,
                carrierId: params.carrierId,
                sortBy: params.sortBy,
                sort: params.sort
            }

            function getDateFormat (dateString: string) {
                if (!dateString) return null

                const date = new Date(dateString)
                date.setDate(date.getDate() + 1)

                const day = date.getDate().toString().padStart(2, '0')
                const month = (date.getMonth() + 1).toString().padStart(2, '0')
                const year = date.getFullYear().toString().padStart(4, '0')
                return `${year}-${month}-${day}`
            }

            if (params.filters) {
                params.filters.forEach((filter: Filter) => {
                    if (filter.queryValue) {
                        if (!newParams[filter.value]) {
                            newParams[filter.value] = filter.queryValue
                        } else {
                            let helper: string[] = []
                            if (Array.isArray(newParams[filter.value])) {
                                helper = [ ...newParams[filter.value] ]
                            } else {
                                helper.push(newParams[filter.value])
                            }

                            if (typeof filter.queryValue === 'string') helper.push(filter.queryValue)

                            newParams[filter.value] = helper
                        }
                    }
                    if (filter.type === 'date') {
                        if (filter.queryValue) {
                            if (Array.isArray(filter.queryValue)) {
                                filter.queryValue = filter.queryValue.sort((a: string, b: string) => {
                                    return new Date(a + '-01').getTime() - new Date(b + '-01').getTime()
                                })
                            }

                            newParams[filter.value] = {
                                startDate: getDateFormat(filter.queryValue[0] || ''),
                                endDate: getDateFormat(filter.queryValue[1] ? filter.queryValue[1] : filter.queryValue[0] || '')
                            }
                        }
                    }
                })
            }
            StatementsServices.getStatementsPaginate(newParams)
                .then(resp => {
                    store.commit('updateStatementsPaginate', resp.data)
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }

    @Action
    deleteStatements (id: number) {
        return new Promise((resolve) => {
            StatementsServices.deleteStatements(id)
                .then(resp => {
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }

    @Action
    downloadStatementFile (id: number) {
        return new Promise((resolve) => {
            StatementsServices.getStatementsFileById(id)
                .then(resp => {
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }
}
